<template>
  <div class="outer-block-options">
    <v-btn-toggle dark>

      <v-tooltip
          right
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              color="blue-grey darken-4" @click="open_modal(block, index)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Edit</span>
      </v-tooltip>

      <v-tooltip
          right
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              color="blue-grey darken-4"
              class="handle"
          >
            <v-icon>
              mdi-cursor-move
            </v-icon>
          </v-btn>
        </template>
        <span>Hold down and move block</span>
      </v-tooltip>

      <v-tooltip
          right
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              @click="clone_block(block)"
              color="blue-grey darken-4"
          >
            <v-icon>
              mdi-transfer
            </v-icon>
          </v-btn>
        </template>
        <span>Clone Block</span>
      </v-tooltip>

      <v-tooltip
          right
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              color="blue-grey darken-4"
              @click="delete_outer_block(block, index)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Delete current block</span>
      </v-tooltip>
    </v-btn-toggle>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  props: {
    block: Object,
    blocks: Array,
    index: Number
  },
  components: {},
  computed: {

  },
  data() {
    return {
      show_model: false,
    }
  },
  methods: {
    open_modal(block, index) {
      let payload = {
        active: true,
        item: block,
        index: index,
        top: document.documentElement.scrollTop || document.body.scrollTop
      };
      this.$store.dispatch('setOuterBlock', payload);
    },
    clone_block(block) {
      this.$store.dispatch('cloneCampaignBlock', {
        block: block,
        index: this.index
      })
    },
    save_outer_options() {
      this.show_model = false;
    },
    close_outer_options() {
      this.show_model = false;
    },
    delete_outer_block(block, index) {
      if (confirm('Are you sure you wish to delete this block?')) {
        this.$store.dispatch('deleteCampaignBlock', {
          step: 0,
          index: index
        });
      }
      console.log('delete');
    },
  }
}
</script>

<style lang="scss">

</style>
